import React, { useState } from 'react';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import SelectList from '../shared/inputs/SelectList';

const LeadSourceSelector = ({
    disabled,
    leadSourceError,
    leadSourceId: initialLeadSourceId,
    subLeadSourceError,
    subLeadSourceId: initialSubLeadSourceId
}) => {
    const [leadSourceId, setLeadSourceId] = useState(initialLeadSourceId);
    const [subLeadSourceId, setSubLeadSourceId] = useState(initialSubLeadSourceId);

    const updateLeadSourceId = ({ target: { value } }) => {
        setLeadSourceId(value);
        setSubLeadSourceId(0);
    }
    const updateSubLeadSourceId = ({ target: { value } }) => setSubLeadSourceId(value);

    const getStyle = disabled ? { pointerEvents: 'none', backgroundColor: '#E9ECEF' } : {};

    return (
        <React.Fragment>
            <Row>
                <Form.Group as={Col}>
                    <SelectList
                        filter={{ franchiseId: window.biztrax.franchiseId }}
                        lookupType="LeadSource"
                        name="Item.LeadSourceId"
                        onChange={updateLeadSourceId}
                        placeholder="Lead Source"
                        required={true}
                        validationError={leadSourceError}
                        value={leadSourceId}
                        style={getStyle}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col}>
                    <SelectList
                        filter={{ leadSourceIds: [leadSourceId], franchiseId: window.biztrax.franchiseId }}
                        lookupType="SubLeadSource"
                        name="Item.SubLeadSourceId"
                        onChange={updateSubLeadSourceId}
                        placeholder="Sub Lead Source"
                        required={true}
                        validationError={subLeadSourceError}
                        value={subLeadSourceId}
                        style={getStyle}
                    />
                </Form.Group>
            </Row>
        </React.Fragment>
    );
}

export default LeadSourceSelector;